<ng-template #toolTipContent>
   <ng-content select="[toolTipContent]"></ng-content>
</ng-template>

<div
   kendoTooltip
   showOn="none"
   [position]="position"
   [tooltipTemplate]="toolTipContent"
   [isTooltipVisible]="isTooltipOpen$ | async"
   (mouseenter)="isTooltipOpen$.next(true)"
   (mouseleave)="isTooltipOpen$.next(false)"
>
   <ng-content></ng-content>
</div>
